module.exports = __webpack_public_path__ + "static/media/jpegIcon.20d764c0.svg";